import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PullToRefresh, InfiniteScroll } from 'antd-mobile'
import { ProductCard } from '../../../components_renew/Mall/ProductCard'
import requests from '../../../requests'

const HomeList = (props) => {
  const history = useHistory()
  const { children } = props
  const [pageIndex, setPageIndex] = useState(0)
  const [data, setData] = useState([])
  const [isLastPage, setIsLastPage] = useState(false)

  async function refresh () {
    setIsLastPage(false)
    await requests.mall.fetchHomeProducts(1)
      .then(res => {
        const { isLastPage, list } = res
        setIsLastPage(isLastPage)
        setData(data.concat(list))
        setPageIndex(pageIndex + 1)
      })
  }

  async function loadMore () {
    await requests.mall.fetchHomeProducts(pageIndex + 1)
      .then(res => {
        const { isLastPage, list } = res
        setIsLastPage(isLastPage)
        setData(data.concat(list))
        setPageIndex(pageIndex + 1)
      })
      .catch(e => {
        setIsLastPage(true)
      })
  }

  function toProductDetails (item) {
    const { id } = item
    // this.props.dispatch(setProductDetailsData(rowData))
    history.push(`/mall/product-details/${id}`)
  }

  function addCart () {

  }

  return (
    <PullToRefresh onRefresh={refresh}>
      <div>
        {children}
      </div>
      <div className={'grid grid-cols-2 gap-1 p-1'}>
        {data.map((item, index) =>
          <ProductCard
            {...item}
            key={index}
            onClick={toProductDetails.bind(this, item)}
            onIconClick={addCart}
          />
        )}
      </div>
      <div>
        <InfiniteScroll hasMore={!isLastPage} loadMore={loadMore}/>
      </div>
    </PullToRefresh>
  )
}
//
// @withRouter
// @connect(state => {
//
//   return state.mallHomeProducts
// })
// class HomeListOld extends React.PureComponent {
//
//   componentDidMount () {
//     // if (!(this.props.data.length > 0)) {
//     //   this.props.dispatch(requestHomeProductsData({ pageIndex: 1 }))
//     // }
//   }
//
//   renderOld () {
//     let { loading, children, dataSource, isLastPage } = this.props
//     return <List
//       className={'home-list'}
//       dataSource={dataSource}
//       renderHeader={() => <div>{children}</div>}
//       renderFooter={() => (<div style={{ padding: 30, textAlign: 'center' }}>
//         {loading ? <DotLoading/> : isLastPage ? '- 已到底部 -' : null}
//       </div>)}
//       renderBodyComponent={() => <div className={'product-card__wrapper'}/>}
//       renderRow={rowData => <ProductCard {...rowData} onClick={this.toProductDetails.bind(this, rowData)}
//                                          onIconClick={this.addCart}/>}
//       pageSize={30}
//       style={{ flex: '1 1 auto', overflow: 'auto', position: 'relative', width: '100%' }}
//       scrollRenderAheadDistance={500}
//       onEndReached={this.onEndReached}
//       onEndReachedThreshold={10}
//     />
//   }
//
//   render () {
//     const { loading, children, data, isLastPage, dispatch } = this.props
//     return (<PullToRefresh onRefresh={() => dispatch(requestHomeProductsData({ pageIndex: 1 }))}>
//         <div>
//           {children}
//         </div>
//         <div className={'grid grid-cols-2 gap-1 p-1'}>
//           {data.map((item, index) =>
//             <ProductCard
//               {...item}
//               key={index}
//               onClick={this.toProductDetails.bind(this, item)}
//               onIconClick={this.addCart}
//             />
//           )}
//         </div>
//         <div>
//           <InfiniteScroll hasMore={!isLastPage} loadMore={this.loadMore}/>
//         </div>
//       </PullToRefresh>
//     )
//   }
//
//   loadMore = async () => {
//     const { loading, isLastPage, pageIndex: p, dispatch } = this.props
//     console.warn('loadMore', p, loading, isLastPage)
//     const pageIndex = p - 1
//     if (loading || isLastPage) return
//     await dispatch(requestHomeProductsData({ pageIndex: pageIndex + 1 }))
//   }
//
//   onEndReached = () => {
//     let { loading, isLastPage, pageIndex } = this.props
//     if (loading || isLastPage) return
//     this.props.dispatch(requestHomeProductsData({ pageIndex: pageIndex + 1 }))
//   }
//
//   toProductDetails = (rowData) => {
//     this.props.dispatch(setProductDetailsData(rowData))
//     this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${rowData['id']}`)
//   }
//
// }

export { HomeList }
